import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';

const Transaction = ({ data }) => {

  console.log("YTR07",data[0]?.date);
  

  const saleTypeIcons = ([
    { type: "subscription", faicon: "fa-indian-rupee-sign" },
    { type: "advertisement", faicon: "fa-rectangle-ad" },
    { type: "society", faicon: "fa-hands-helping" },
    { type: "community", faicon: "fa-people-group" },
    { type: "inventory", faicon: "fa-boxes-stacked" },
    { type: "advertisement", faicon: "fa-rectangle-ad" },
  ]);

  return (
    <>
      <div className='transaction_wrapper'>
        <div className='net_income_head_wrapper'>
          <h5>Sales in {moment(data[0]?.date).format('MMMM YYYY')}</h5>
          {/* <i class="fa-solid fa-ellipsis"></i> */}
          <Link to="/sales"><i class="fas fa-long-arrow-alt-right"></i></Link>
        </div>
        {
        data.length >0 ?
        data.map((item, i) => {
          return (
            <>
              <div className='transaction_products_wrapper'>
                <div className='product_details_wrapper'>
                  <div className='product_img'>
                    <i 
                    // class="fa-solid fa-indian-rupee-sign" 
                    className={`fa-solid ${saleTypeIcons.find(itm => itm.type === item?.saleType.toLowerCase())?.faicon || "fa-piggy-bank"}`}></i>
                  </div>
                  <div className='product_name_div'>
                    <h6 style={{
                      textTransform:"capitalize"
                    }}>{item?.saleType}</h6>
                    <p>{moment(item?.date).format("MMMM Do YYYY")}</p>
                  </div>
                </div>
                <div className='product_status_wrapper'>
                  <h6><i className="fa fa-indian-rupee-sign"></i> {item?.price.toFixed(2)}</h6>
                  <p>{item?.city[0]?.name}</p>
                </div>
              </div>
            </>
          )
        }):<><div style={{
          fontSize:"85%",
          margin:"1em 0",
          color:"#ff0000"
        }}>No Sales data found!</div></>}


      </div>
    </>
  )
}

export default Transaction
